import type { ListBuilderList } from '../../../types';
import { createQuoteShopStandardColumns } from '../columns';
import {
	QUOTE_SHOP_MOBILE_CARD_CONFIG,
	QUOTE_SHOP_STANDARD_REQUIRED_FIELDS,
} from '../shared';

/**
 * Quote Shop Previously Purchased list configuration
 * Items previously purchased by the client
 */
export const quoteShopPreviouslyPurchasedList: ListBuilderList = {
	id: 'quote_shop_previously_purchased',
	cacheTTL: 600000,
	name: 'Previously Purchased',
	type: 'default',
	active: true,
	sortOrder: 3,
	columns: createQuoteShopStandardColumns(),
	description: 'Items previously purchased by the client',
	defaultSortId: 'column-item_details-asc',
	requiredFields: QUOTE_SHOP_STANDARD_REQUIRED_FIELDS,
	mobileCardConfig: QUOTE_SHOP_MOBILE_CARD_CONFIG,
	filterRules: {
		item_filters: {
			defaultValue: [
				{
					id: 'in_stock',
					label: 'In Stock',
				},
				{
					id: 'previously_purchased',
					label: 'Previously Purchased',
				},
			],
		},
	},
};
